import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../lib/firebase';
import './Download.css';
import '../Authentication/GetAuth.css';
import Loader from '../loader/Loader';
import expo from '../assets/expo.png';


function Download() {
    // State to hold the Expo preview link
    const [previewLink, setPreviewLink] = useState(null);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();


    useEffect(() => {
        // Fetch the preview link from Firestore
        const fetchPreviewLink = async () => {
            try {
                const docRef = doc(db, 'shipments', 'wallets');
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    // Assuming the preview link is stored under the field 'expoLink'
                    setPreviewLink(docSnap.data().expoLink);
                } else {
                    console.log('No such document!');
                }
            } catch (error) {
                console.error('Error fetching preview link:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchPreviewLink();
    }, []);

    if (loading) {



        return <Loader />; // Or any loading spinner/animation
    }

    if (!previewLink) {
        return <p>No preview link available at the moment.</p>;
    }

    // Navigate back to the previous page
    const handleGoBack = () => {
        navigate(-1);
    };

    return (
        <div className="pageCover link-container">
            <div className="link-card">
                <img src={expo} alt="Download Expo" className='expo' />
                <h2>How to Install with the Expo Go App</h2>
                <p>
                    The Expo Go app allows you to preview our Mobile App on your mobile device.
                    To use the Expo Go app:
                </p>
                <ol>
                    <li>Download and install the Expo Go app from your device's app store (available on iOS and Android).</li>
                    <li>Open the Expo Go app on your device.</li>
                    <li>Make sure your device is connected to the internet.</li>
                    <li>After installing, Click the button below to open the preview link in the Expo Go app.</li>
                </ol>
                <p>You do not need to do this next time, just open Expo Go and click on the App from the history.</p>

                <a href={previewLink} target="_blank" rel="noopener noreferrer">
                    <button className="copy-button">Open Preview in Expo Go</button>
                </a>

                <button onClick={handleGoBack} className="downloadBtn">Go Back</button>

            </div>
        </div>
    );
}

export default Download;
